<template>
  <div class="i-cell-value">
    <DocumentThumbnail
      @click.prevent="action"
      :href="item.url"
      target="_blank"
      :mimeType="item.mime_type"
      :thumbnail="item.preview_url"
      :version="previewVersion"
      :style="{width: '60px'}"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapBrowserState, mapBrowserActions } from '@/store';
import globals from '@/globals';
import DocumentThumbnail from '@/components/browser/documents/DocumentThumbnail.vue';

export default defineComponent({
  inheritAttrs: false,
  components: {
    DocumentThumbnail,
  },
  props: {
    item: Object,
  },
  computed: {
    ...mapBrowserState(['isInsertMode']),
    previewVersion() {
      return btoa(this.item.finished_at);
    },
  },
  methods: {
    ...mapBrowserActions(['insertVariant']),
    action() {
      return this.isInsertMode ? this.insert() : this.preview();
    },
    insert() {
      const {
        node_id: nodeId,
        insert_url: insertUrl,
        url,
        filesize,
      } = this.item;

      this.insertVariant({
        nodeId,
        variantUri: insertUrl || url,
        contentLength: filesize,
      });
    },
    preview() {
      const { url } = this.item;
      globals.context.open(url, '_blank');
    },
  },
});
</script>

<style scoped lang='scss'>
.i-cell-value {
  margin: 0 auto;
  overflow: visible;
}
</style>
